import { render, staticRenderFns } from "./ExerciseDetails.vue?vue&type=template&id=98dfb5e4&"
import script from "./ExerciseDetails.vue?vue&type=script&lang=js&"
export * from "./ExerciseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports